import isEmpty from 'lodash/isEmpty';
import {Fee} from '../shared/model/Fee';

export const FeeHelper = {
  getTotalFee: (fees: Fee[]): number =>
    isEmpty(fees) ?
      0
      : fees.map(fee => fee.feeAmount).reduce((totalFee, currentFee) => totalFee + currentFee)
};